import {
  Accordion,
  AccordionDetails,
  Divider,
  Grid,
  SelectChangeEvent,
  Typography,
  useEventCallback,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useState } from 'react';
import { FormikProps } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { PmiButton } from 'shell/components/shared/button';
import PmiTextField from 'shell/components/shared/text-field';
import { FiltersFormReleaseMode } from 'front-office/view-models/release-mode';
import { DatePicker } from '@mui/lab';
import RegisterTypeList from '../shared/register-type-list';
import CodeAnprList from '../shared/code-anpr-list';
import UseModeList, { FlagTyDomain } from '../shared/use-mode-list';

interface FiltersReleaseModeProps {
  filtersForm: FormikProps<FiltersFormReleaseMode>;
}

const FiltersReleaseMode = ({ filtersForm }: FiltersReleaseModeProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const onChangeRegisterTypeList = useEventCallback((event: SelectChangeEvent<string>) => {
    filtersForm.setFieldValue('register', event.target.value);
  });

  const onChangeCodeAnprList = useEventCallback((event: SelectChangeEvent<string>) => {
    filtersForm.setFieldValue('exemption', event.target.value);
  });

  const onChangeUseModeList = useEventCallback((event: SelectChangeEvent<string>) => {
    filtersForm.setFieldValue('use', event.target.value);
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-release-mode-content"
        id="panel-release-mode-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filtersForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Codice modalità rilascio"
                label="Codice modalità rilascio"
                id="code"
                name="code"
                fullWidth
                type="text"
                variant="outlined"
                value={filtersForm.values.code}
                onChange={filtersForm.handleChange}
                inputProps={{
                  maxLength: '5',
                }}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <PmiTextField
                aria-label="Descrizione modalità rilascio"
                label="Descrizione modalità rilascio"
                id="description"
                name="description"
                fullWidth
                type="text"
                variant="outlined"
                value={filtersForm.values.description}
                onChange={filtersForm.handleChange}
                inputProps={{
                  maxLength: '50',
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12} md={5}>
              <RegisterTypeList
                onChange={onChangeRegisterTypeList}
                value={filtersForm.values.register || ''}
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <CodeAnprList
                onChange={onChangeCodeAnprList}
                value={filtersForm.values.exemption || ''}
              />
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12} md={5}>
              <UseModeList
                onChange={onChangeUseModeList}
                value={filtersForm.values.use || ''}
                params={{
                  tyDomain: FlagTyDomain.Elettorale,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              Periodo di validità della modalità rilascio
            </Grid>
            <Grid item xs={12} md={5}>
              <DatePicker
                label="Dal"
                aria-label="Dal"
                value={filtersForm.values.dateFrom || null}
                onChange={(date) => {
                  filtersForm.setFieldValue('dateFrom', date);
                }}
                renderInput={(params) => (
                  <PmiTextField id="date-from" {...params} fullWidth helperText="" />
                )}
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <DatePicker
                label="Al"
                aria-label="Al"
                value={filtersForm.values.dateTo || null}
                onChange={(date) => {
                  filtersForm.setFieldValue('dateTo', date);
                }}
                renderInput={(params) => (
                  <PmiTextField id="date-to" {...params} fullWidth helperText="" />
                )}
              />
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="flex-end">
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filtersForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersReleaseMode.displayName = 'Filters release mode component';

export default FiltersReleaseMode;
